<template>
  <div>
    <div class="w-100 d-inline-block bg-introduction padding-bottom-five">
      <div class="container autoContent">
        <div class="row">
          <div class="col-xl-8 col-12 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block margin-xl-top-5">
              <h1 class="text-black fw-bold text-full-28 family-grand-stander margin-bottom-3 text-xs-size-20">
                Mobile Rabbit Grooming
              </h1>
              <p class="text-black text-size-14 family-inter-light text-full-13 margin-bottom-3">
                Are you a pet lover searching for the best affordable rabbit grooming services in Dubai? Welcome to Dubai Pet Groomer. where pets of all sizes and shapes are provided the utmost royal treatment. Pet grooming is more than just a stylish makeover; it is a crucial part of maintaining your pet’s health and happiness
              </p>
              <p class="text-black text-size-14 family-inter-light text-full-13 margin-bottom-3">
                At Dubai Pet Grooming, we offer affordable services from gentle brushing to nail trimming and much more to keep your pets looking their best.
              </p>
            </div>
          </div>
          <div class="col-xl-4 col-12 mt-3 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block 
              dog-about-image">
              <img class="w-100" v-lazy="require('@/assets/images/rabbit-grooming-rabbit-groomer-mobile-rabbit-grooming.png')" alt="rabbit grooming, rabbit groomer, mobile rabbit grooming">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-gallery gallery-section">
      <div class="container autoContent">
        <div class="row margin-top-4">
          <div class="col-12">
            <div class="w-100 d-inline-block text-center margin-top-2">
              <p class="mb-0 text-size-14 text-uppercase nav-color fw-bold inter-bold-family text-full-14">
                OUR Plans
              </p>
              <h2 class="half-black fw-bold text-full-24 family-grand-stander text-uppercase text-size-24 margin-bottom-2 text-xs-size-20">
                Mobile Rabbit Grooming Services We Provide
              </h2>
              <p class="margin-bottom-2 text-size-14 text-black inter-regular-family d-block w-85 m-auto w-xs-100 w-sm-100 w-md-100 w-ipad-100 text-full-13">
                Dubai Pet Groomer is pleased to build the most creative, advanced, pet-friendly, and cost-effective mobile rabbit grooming facilities. It offers a variety of services to meet your pet's essential requirements.  
              </p>
            </div>
          </div>
        </div>
        <div class="row margin-top-4 margin-bottom-4">
      <div class="col-12">
        <div class="w-100 d-inline-block gallery-slider about-slider position-relative">
          <div class="carousel-container">
            <transition-group class="carousel" tag="div">
              <div v-for="(plan) in planDetailPrices" :key="plan.id" class="slide">
                <div class="card w-100 d-inline-block border-0 rounded-4">
                  <!-- <img class="slide-image w-100" :src="$getImageUrl(plan.image)" :alt="plan.image" /> -->
                  <img class="slide-image w-100" v-lazy="$getImageUrl(plan.image)" :alt="plan.image">
                  <div class="card-body">
                    <h3 class="card-title text-size-14 inter-bold-family overflow-hidden margin-bottom-2 text-full-14">
                      {{ plan.name }}
                    </h3>
                    <p class="card-text text-black text-size-14 inter-regular-family overflow-hidden margin-bottom-2 text-full-13">
                      {{ plan.description }}
                    </p>
                    <a href="javascript:void(0)" class="nav-color rounded-5 text-uppercase text-size-13 d-inline-block medium-family border-blue me-xl-2 me-3 book-service-btn text-full-13"
                    @click="addToCart(plan)">
                      Book Service
                    </a>
                    <span class="text-size-16 nav-color fw-bold family-grand-stander d-inline-block mt-xl-0 mt-2 mt-lg-0 mt-md-0 text-full-16">
                      {{ plan.unit }} {{ plan.price }} 
                    </span>
                  </div>
                </div>
              </div>
            </transition-group>
            <div class="carousel-controls">
              <a href="javascript:void(0)" class="carousel-prev-btn position-absolute" @click="previous">
                <img class="position-absolute" src="@/assets/images/prev-left-icon.svg" alt="" />
              </a>
              <a href="javascript:void(0)" class="carousel-next-btn position-absolute" @click="next">
                <img class="position-absolute" src="@/assets/images/next-right-icon.svg" alt="" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
      </div>
    </div>
    
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row mt-xl-5 mt-4">
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 col-lg-6">
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a
                class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseExample"
                aria-expanded="false"
                aria-controls="collapseExample"
                @click="toggleCollapse"
                >
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              How frequently should I groom my rabbit?
              </span>
              </a>
              <div :class="['collapse', { show: isOpen }]" id="collapseExample">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    You should groom your rabbit at least once a week to maintain its coat healthy and free of mats and tangles. The frequency with which a rabbit must be groomed is determined by its breed; short-haired rabbits require grooming occasionally, but long-haired rabbits require grooming weekly.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample2" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              How much time does a rabbit grooming session require?
              </span>
              </a>
              <div class="collapse" id="collapseExample2">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    It depends significantly on the services you choose. However, we will groom your rabbit in 30 minutes to 2 hour.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample3" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              Can I bathe my rabbit?
              </span>
              </a>
              <div class="collapse" id="collapseExample3">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    Bathing is essential keep you rabbit’s hygiene, make sure the water is lukewarm and use a small quantity of rabbit-friendly shampoo.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample4" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              What to do to clean Rabbit’s dirty coat?
              </span>
              </a>
              <div class="collapse" id="collapseExample4">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    Work lightly with a brush or comb, starting at the borders and working inward. If the fur is in miserable condition, it is essential to hire a professional pet groomer.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample5" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              How should I handle shedding and loose fur?
              </span>
              </a>
              <div class="collapse" id="collapseExample5">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    Rabbits shed many times every year, particularly during seasonal changes. Brushing regularly during shedding seasons helps to remove loose fur and prevents hairballs from developing when rabbits groom themselves.
                  </p>
                </div>
              </div>
            </div>
            <div class="w-100 d-inline-block pets-collapse margin-bottom-3 bg-white">
              <a class="family-filson-bold text-black text-size-14 fw-bold w-100 d-inline-block padding-top-2 text-full-14" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample6" aria-expanded="false" aria-controls="collapseExample">
              <span class="float-start margin-right-2">
              <i class="fa fa-check-circle-o nav-color" aria-hidden="true"></i>
              </span>
              <span class="float-start w-92 text-full-14 text-size-14">
              Are your grooming tools safe for rabbits?
              </span>
              </a>
              <div class="collapse" id="collapseExample6">
                <div class="card card-body padding-top-2 p-0 border-0">
                  <p class="mb-xl-0 mb-1 text-size-14 text-black family-inter-light text-full-13">
                    Yes, we utilize modern yet secure instruments for each session. Our pet groomers are trained to handle rabbits safely, reducing stress and preventing damage. You can rely on us for that.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-12 col-sm-6 col-md-6 
            col-lg-6">
            <div class="w-100 d-inline-block">
              <h2 class="text-black fw-bold filson-black-family text-full-28 w-65 w-xs-100 w-sm-100 w-md-100 w-ipad-100 margin-bottom-2 text-xs-size-20">
                What makes you choose us?
              </h2>
              <p class="mb-0 text-size-14 text-black family-inter-light text-full-13">
                We go above and beyond at Dubai Pet Groomers to make sure your pet's visit is safe, stress-free, and customize to their unique needs. Through our highly experience staff, quality products, and uncompromising commitment to your pet's well-being, we're here to make grooming services an enjoyable and relaxing experience every time.
              </p>
            </div>
            <div class="w-100 d-inline-block margin-top-3 about-video-image">
              <!-- <img class="w-100 rounded-4" v-lazy="require('@/assets/images/rabbit-about-video-image.png')" alt=""> -->
              <img class="w-100 rounded-4" v-lazy="require('@/assets/images/cheap-bunny-grooming-affordable-bunny-grooming-trained-rabbit-groomer.png')" alt="cheap bunny grooming, affordable bunny grooming, trained rabbit groomer">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row margin-top-2 margin-bottom-2">
          <div class="col-12">
            <ul class="w-100 d-inline-block ps-0 bread-crumb mb-0 margin-top-1">
              <li class="float-start margin-right-2">
                <router-link class="text-black text-size-14 medium-family text-full-13" to="/"><i class="fa fa-home nav-color" aria-hidden="true"></i> Home /</router-link>
              </li>
              <li class="float-start">
                <router-link class="text-black text-size-14 medium-family text-full-13" to="/services/">Services</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { applyServicePageSchema } from '@/utils/seo';
  import { RABBIT_GROOMING_FAQS } from '@/utils/servicePageFaqs';

  export default {
    name: 'rabbitGroomingBannerComponent',
    data() {
    return {
      isOpen: true,
      planDetailPrices: [], // Initialize as an empty array
    };
  },
      mounted() {
      this.fetchServiceCategories();
      this.applyStructuredData();
  },
      computed: {
        iconClass() {
          return this.isOpen ? "fa fa-check-circle-o text-green" : "fa fa-check-circle-o nav-color";
        },
      },
      methods: {
        applyStructuredData() {
          applyServicePageSchema({
            name: 'Rabbit Grooming Services in Dubai',
            description: this.$route.meta?.description || 'Rabbit grooming services in Dubai.',
            path: this.$route.path,
            offers: (this.planDetailPrices || []).map((plan) => ({
              name: plan.name || plan.title || 'Rabbit Grooming',
              price: plan.price,
            })),
            faqs: RABBIT_GROOMING_FAQS,
          });
        },
        addToCart(service) {
        const cartData = localStorage.getItem('cart');
        let cart = cartData ? JSON.parse(cartData) : []; // Parse the cart or initialize as an empty array

        const serviceExists = cart.find((item) => item.id === service.id);

        if (serviceExists) {
          serviceExists.count++;
        } else {
          cart.push({ ...service, count: 1 });
        }
        localStorage.setItem('cart', JSON.stringify(cart));
        this.$router.push('/booking/');
      },
      async fetchServiceCategories() {
        try {
          const response = await this.$axios.post('/get-service-categories', {
            website_name: this.$websiteName,
            category_name: 'Rabbit Grooming',
          });
          if (response.data.status === "success") {
            this.planDetailPrices = response.data.planDetailPrices; // Assign the fetched data
            this.applyStructuredData();
          } else {
            console.error("Failed to fetch categories:", response.data);
          }
        } catch (error) {
          console.error('Error fetching categories:', error.response || error.message);
        }
      },
    previous() {
      const last = this.planDetailPrices.pop();
      this.planDetailPrices = [last].concat(this.planDetailPrices);
    },
    next() {
      const first = this.planDetailPrices.shift();
      this.planDetailPrices = this.planDetailPrices.concat(first);
    },
    toggleCollapse() {
      this.isOpen = !this.isOpen;
    },
  },
  }
</script>
<style scoped></style>